import apiClient from '@/services/api';

export interface CourseListRes {
    status: number;
    error: boolean;
    message: string;
    data: CourseListData;
}

export interface CourseListData {
    data: CourseDatum[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
}

export interface CourseDatum {
    id: string;
    course_name: string;
    description: string;
    status: string; // "ACTIVE" | "INACTIVE"
    created_by: string;
    created_at: string;
    updated_at: string;
}

export interface CreateCoursePayload {
    course_name: string;
    description: string;
    status?: string;
}

export interface UpdateCoursePayload {
    course_name?: string;
    description?: string;
    status?: string;
}

export interface GetCourseRes {
    status: number;
    error: boolean;
    message: string;
    data: CourseDatum;
}

const coursesService = {
    getCourses: async (
        page = 1,
        limit = 10,
        statusFilter?: string,
        search?: string,
    ): Promise<CourseListRes> => {
        const res = await apiClient.get<CourseListRes>('/courses', {
            params: {
                page,
                limit,
                ...(statusFilter && { status: statusFilter }),
                ...(search && search.trim() !== '' ? { search: search.trim() } : {}),
            },
        });
        return res.data;
    },

    createCourse: async (payload: CreateCoursePayload): Promise<GetCourseRes> => {
        const res = await apiClient.post<GetCourseRes>('/courses', payload);
        return res.data;
    },

    updateCourse: async (id: string, payload: UpdateCoursePayload): Promise<GetCourseRes> => {
        const res = await apiClient.patch<GetCourseRes>(`/courses/${id}`, payload);
        return res.data;
    },

    getCourse: async (id: string): Promise<GetCourseRes> => {
        const res = await apiClient.get<GetCourseRes>(`/courses/${id}`);
        return res.data;
    },

    deleteCourse: async (id: string): Promise<{ status: number; error: boolean; message: string; data: null }> => {
        const res = await apiClient.delete<{ status: number; error: boolean; message: string; data: null }>(`/courses/${id}`);
        return res.data;
    },
};

export default coursesService;
